import React from "react";
import HomePhoto from "../resource/zihao2.png";

import "./HomePage.css";
import { HEIGHT, OVERLAY_WIDTH } from "../store/DEFAULT";
import Overlay from "../components/Overlay";
import OverlayText from "../components/OverlayText";

function HomePage(props) {
  return (
    <div className="homePage">
      <div style={{ height: HEIGHT, width: "100%" }}>
        <img
          src={HomePhoto}
          alt=""
          style={{
            objectFit: "cover",
            height: "725px",
            width: OVERLAY_WIDTH,
            display: "block",
            position: "absolute",
            top: "0",
            left: "200px",
          }}
        />
        <Overlay />
        <OverlayText
          text={"Welcome"}
          styles={{ fontSize: "30vh", top: "25%" }}
        />
        <OverlayText text={"to my"} styles={{ fontSize: "15vh" }} />
        <OverlayText
          text={"⭐website⭐"}
          styles={{ fontSize: "25vh", top: "80%" }}
        />
      </div>
    </div>
  );
}
export default HomePage;
